export default __webpack_public_path__ + "static/media/moni_token.a7dbcce4.svg";